import { render } from "./domian.vue?vue&type=template&id=0a86d5b6&scoped=true"
import script from "./domian.vue?vue&type=script&lang=js"
export * from "./domian.vue?vue&type=script&lang=js"

import "./domian.vue?vue&type=style&index=0&id=0a86d5b6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a86d5b6"]])

export default __exports__